import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const accessToken =
    localStorage.getItem("accessToken") || sessionStorage.getItem("accessToken");

  if (!accessToken) {
    return <Navigate to="/not-access" />;
  }

  return element;
};

export default PrivateRoute;
